<template>
  <div class="home">
    <page-wrapper :videoConfig="videoConfig">
      <template v-slot:main>
        <p>„Life is more exciting when you are POPULAR“ isn’t just a claim. It’s a promise.</p>
        <p>We are a data based creative tech, communication and content production company.</p>
        <p>We are skilled, service-oriented, fast, easy and fun to work with.</p>
      </template>
    </page-wrapper>
  </div>
</template>

<script>
  import PageWrapper from '@/components/PageWrapper'

  export default {
    name: 'Home',
    components: {
      PageWrapper
    },
    data() {
      return {
        videoConfig: {
          srcL: require('../assets/video/Popular_Website_Moodfilm_V04_CLEAN_Small.mp4'),
          posterL: require('../assets/video/Popular_Website_Moodfilm_V04_CLEAN.jpg'),
          srcM: require('../assets/video/Popular_Website_Moodfilm_V04_CLEAN_Small.mp4'),
          posterm: require('../assets/video/Popular_Website_Moodfilm_V04_CLEAN.jpg'),
          srcS: require('../assets/video/Popular_Website_Moodfilm_V04_CLEAN_Small.mp4'),
          posterS: require('../assets/video/Popular_Website_Moodfilm_V04_CLEAN.jpg')
        }
      }
    }
  }
</script>

<style>
  a.nav-link {
    color: #ffffff;
    padding: 0;
    margin-bottom: 10px;
    font-size: .9rem;
  }
  a.nav-link.active, a.nav-link:hover, .nav-link:focus {
    color: #ffffff;
    text-decoration: underline;
  }
  .tab-pane {
    font-size: .9rem;
  }
</style>
